import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
import ItemType from '../../../../components/modules/master/item-type';
import ItemTypeMiddleware from '../../../../middleware/modules/master/itemtype';
import i18n from '../../../../i18n';
import { Helmet } from 'react-helmet';
// middlewares


const mapStateToProps = ({ auth,itemType }) => ({
  isProcessing: itemType.isProcessing,
  isError: itemType.isError,
  errorMessage: itemType.errorMessage,
  datalist:itemType.data,
  helperItemType: itemType.helperItemType,
  showModal:itemType.showModal
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    create: () =>ItemTypeMiddleware.create(),
    reset: () =>ItemTypeMiddleware.resetList(),
    search: data =>ItemTypeMiddleware.list(data),
    update: data =>ItemTypeMiddleware.update(data),
    getHelper: () => ItemTypeMiddleware.getHelper(),
    delete: (id,search) =>ItemTypeMiddleware.beforeDelete(id,search),
  }, dispatch);
};
class ItemTypeContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.any,
    datalist: PropTypes.object,
    search: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: [],
  }

  constructor(props){
    super(props)
    this.deleteItem=this.deleteItem.bind(this);
    this.createItem=this.createItem.bind(this);
    this.updateItem=this.updateItem.bind(this);
  }

  componentWillMount() {
    const search = {
      limit: 10,
    };
   this.props.reset();
   this.props.search(search);
  }

  deleteItem(id,search){
    this.props.delete(id,search)
  }
  updateItem(id){
    this.props.getHelper();
    
    this.props.update(id)
  }
  createItem(){
    this.props.create()
    this.props.getHelper();
  }
  render() {
    const {isProcessing, search , datalist,showModal} = this.props;
    return (
      <React.Fragment>
        <Helmet>
          <title>
            {i18n.t("Item Type List")}
          </title>
        </Helmet>
      <ItemType
        {...this.props}
        search={search}
        data={datalist}
        isProcessing={isProcessing}
        showModal={showModal}
        deleteItem={this.deleteItem}
        updateItem={this.updateItem}
        createData={this.createItem}
      />
      </React.Fragment>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ItemTypeContainer);
